"use client"; // Error boundaries must be Client Components
export default function GlobalError({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  console.log("error", error);
  window.location.href = "./goWrong.html";
  // const router = useRouter()
  // router.push("./goWrong.html")

  // return (
  //   // global-error must include html and body tags
  //   <html>
  //     <body>
  //       <h2>Sorry, the data is wrong</h2>
  //       <p>Try refreshing it again.</p>
  //       <button onClick={() => reset()}>Go home</button>
  //     </body>
  //   </html>
  // )
}
